function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgCrwnClothingShoppingBagIcon = function SvgCrwnClothingShoppingBagIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407.453 407.453",
    style: {
      enableBackground: "new 0 0 407.453 407.453"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M255.099,116.515c4.487,0,8.129-3.633,8.129-8.129c0-4.495-3.642-8.129-8.129-8.129H143.486 c-4.487,0-8.129,3.633-8.129,8.129c0,4.495,3.642,8.129,8.129,8.129H255.099z"
  }), React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M367.062,100.258H311.69c-4.487,0-8.129,3.633-8.129,8.129c0,4.495,3.642,8.129,8.129,8.129h47.243 v274.681H48.519V116.515h44.536c4.487,0,8.129-3.633,8.129-8.129c0-4.495-3.642-8.129-8.129-8.129H40.391 c-4.487,0-8.129,3.633-8.129,8.129v290.938c0,4.495,3.642,8.129,8.129,8.129h326.671c4.487,0,8.129-3.633,8.129-8.129V108.386 C375.191,103.891,371.557,100.258,367.062,100.258z"
  }), React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M282.59,134.796c4.487,0,8.129-3.633,8.129-8.129V67.394C290.718,30.238,250.604,0,201.101,0 c-49.308,0-89.414,30.238-89.414,67.394v59.274c0,4.495,3.642,8.129,8.129,8.129s8.129-3.633,8.129-8.129V67.394 c0-28.198,32.823-51.137,73.36-51.137c40.334,0,73.157,22.939,73.157,51.137v59.274 C274.461,131.163,278.095,134.796,282.59,134.796z"
  }), React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M98.892,147.566c0,11.526,9.389,20.907,20.923,20.907c11.534,0,20.923-9.38,20.923-20.907 c0-4.495-3.642-8.129-8.129-8.129s-8.129,3.633-8.129,8.129c0,2.561-2.089,4.65-4.666,4.65c-2.569,0-4.666-2.089-4.666-4.65 c0-4.495-3.642-8.129-8.129-8.129S98.892,143.071,98.892,147.566z"
  }), React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M282.59,168.473c11.534,0,20.923-9.38,20.923-20.907c0-4.495-3.642-8.129-8.129-8.129 c-4.487,0-8.129,3.633-8.129,8.129c0,2.561-2.089,4.65-4.666,4.65c-2.577,0-4.666-2.089-4.666-4.65 c0-4.495-3.642-8.129-8.129-8.129c-4.487,0-8.129,3.633-8.129,8.129C261.667,159.092,271.055,168.473,282.59,168.473z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCrwnClothingShoppingBagIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crwn_clothing_shopping_bag_icon.30f07071.svg";
export { ForwardRef as ReactComponent };